import { branch, renderComponent } from 'recompose'
import { DesktopDropdown, IDropdown, MobileDropdown } from './component'

const dropdownSwitch = branch<IDropdown>(
  () => window.matchMedia('(any-hover: hover)').matches,
  renderComponent(DesktopDropdown)
)

export const Dropdown = dropdownSwitch(MobileDropdown)

export default Dropdown
